import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import TableRow from '@mui/material/TableRow';
import TableCell from 'src/components/Table/TableCell';
import { useTranslation } from 'react-i18next';
import { formatCardBrand } from 'src/utils/cards';
import MoreMenu from 'src/components/MoreMenu/MoreMenu';
import {
  deleteCreditCard,
  DELETE_CREDIT_CARD
} from 'src/store/actions/clientActions';
import { useDispatch, useSelector } from 'react-redux';
import ConfirmationDialog from 'src/components/ConfirmDialog/ConfirmationDialog';
import { CommonActions } from 'src/utils/constants/clients';
import { isLoadingSelector } from 'src/store/selectors/statusSelector';

const CreditCardsRow = ({
  id,
  clientId,
  brand,
  last4Digits,
  bank,
  expirationDate
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);

  const isDeleting = useSelector(
    isLoadingSelector([DELETE_CREDIT_CARD.action])
  );

  const formattedBrand = formatCardBrand(brand);
  const options = [
    {
      label: t('COMMON.DELETE'),
      name: CommonActions.DELETE
    }
  ];

  const handleCloseDeleteDialog = useCallback(() => {
    setOpenDeleteDialog(false);
  }, []);

  const handleClickOption = useCallback(action => {
    if (action === CommonActions.DELETE) {
      setOpenDeleteDialog(true);
    }
  });

  const handleDeleteCard = useCallback(() => {
    dispatch(deleteCreditCard(id, clientId, handleCloseDeleteDialog));
  }, [clientId, dispatch, id]);

  return (
    <>
      <TableRow hover>
        <TableCell align="center">
          {formattedBrand || t('COMMON.NO_DATA')}
        </TableCell>
        <TableCell align="center">
          {last4Digits ? `**** **** **** ${last4Digits}` : t('COMMON.NO_DATA')}
        </TableCell>
        <TableCell align="center">{bank || t('COMMON.NO_DATA')}</TableCell>
        <TableCell align="center">
          {expirationDate || t('COMMON.NO_DATA')}
        </TableCell>
        <TableCell align="right">
          <MoreMenu
            options={options}
            handleClickOption={handleClickOption}
            editDisabled
            disabled={isDeleting}
          />
        </TableCell>
      </TableRow>

      <ConfirmationDialog
        open={openDeleteDialog}
        handleClose={handleCloseDeleteDialog}
        onSubmit={handleDeleteCard}
        title={t('CLIENTS_VIEW.BILLING_DETAIL.DELETE_CARD_TITLE')}
        description={t('CLIENTS_VIEW.BILLING_DETAIL.DELETE_CARD_DESCRIPTION')}
        isLoading={isDeleting}
      />
    </>
  );
};

CreditCardsRow.propTypes = {
  brand: PropTypes.string,
  last4Digits: PropTypes.string,
  bank: PropTypes.string,
  expirationDate: PropTypes.string,
  clientId: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired
};

export default CreditCardsRow;
